// extracted by mini-css-extract-plugin
export default {"loader":"SuspenseLoader_loader__1W9Dk","spinner-3":"SuspenseLoader_spinner-3__pHUlZ","s3":"SuspenseLoader_s3__VLgk7"};